/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React, { useMemo } from "react";
import { TViewComponent } from "../../../../view/IView";
import { DocumentationView } from "../DocumentationView";
import { Layout } from "../../../../ui/components/Layout/Layout";
import { DocumentationSidebar } from "./DocumentationSidebar";
import { DocumentationContent } from "./DocumentationContent";
import { DocumentationToolbar } from "./DocumentationToolbar";

export const DocumentationMain: TViewComponent<DocumentationView> = ({ view }) => {
	const layoutState = useMemo(() => view.getLayout(), [view]);

	const renderComponent = (componentName: string) => {
		switch (componentName) {
			case "sidebar":
				return <DocumentationSidebar view={view} />;
			case "content":
				return <DocumentationContent view={view} />;
			case "toolbar":
				return <DocumentationToolbar view={view} />;
			default:
				return null;
		}
	};

	return <Layout state={layoutState} renderComponent={renderComponent} />;
};
